module.exports = __webpack_public_path__ + "static/domain-whois_2-bdadfac7df88b13cc07bc67e3d1ea031.jpg";